import { useParams, useNavigate } from "react-router-dom";
import AdminDemoTab from "./AdminDemoTab";
import { useEffect, useState } from "react";
import { fetchCourseById } from "./adminCourseService";
import "./adminCourses.css";

const AdminCourseDemoPage = () => {
  const { id: courseId } = useParams();
  const navigate = useNavigate();
  const [courseName, setCourseName] = useState("");

  useEffect(() => {
    fetchCourseById(courseId)
      .then((res) => setCourseName(res.data?.name || ""))
      .catch(() => {});
  }, [courseId]);

  return (
    <div>
      <div className="ac-header">
        <div>
          <h2>Demo Classes</h2>
          <div style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "0.2rem" }}>
            {courseName}
          </div>
        </div>
        <button className="ac-btn ac-btn-ghost" onClick={() => navigate("/admin/courses")}>
          ← Courses
        </button>
      </div>

      <AdminDemoTab courseId={courseId} />
    </div>
  );
};

export default AdminCourseDemoPage;
